import React, { useContext } from 'react';
import { DevicesContext, IDevicesContext } from 'modules/Devices/Devices/devicesState/devicesContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, devices } = useContext<IDevicesContext>(DevicesContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={devices.count ? 800 : undefined}
		/>
	);
};

export default Search;
